import React from 'react';
import styled from 'styled-components';

import { configValue } from 'utils/config';
import recaptcha from 'utils/recaptcha';

const StyledRecaptchaInput = styled.div`
  height: 78px;
`;
export default class RecaptchaInput extends React.Component<{
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (...args: Array<any>) => any;
}> {
  setupRecaptcha = (el: Element | null | undefined) => {
    if (!el) return;
    recaptcha().then((r) => {
      r.render(el, {
        sitekey: configValue('google', 'recaptcha', 'siteKey'),
        callback: (response) => {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          this.props.onChange(response);
        },
        'expired-callback': () => {
          // Remove old value because it't no longer valid
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          this.props.onChange();
        },
      });
    });
  };

  render() {
    return <StyledRecaptchaInput ref={this.setupRecaptcha} />;
  }
}
